import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  menuOpen = false;
  authChecked = false;

  ngOnInit(): void {
    const auth = getAuth();
    onAuthStateChanged(auth, () => {
      this.authChecked = true;
    });
  }
}
